import Radio from './radio'

export const AmuiRadio = Radio

export default Vue => Vue.component(Radio.name, Radio)
